@if (!canEdit) {
  <div
    [rtTooltip]="workLocationsTooltip()"
    [rtTooltipEnabled]="workLocationsTooltipEnabled()"
    [rtTooltipPosition]="'below'"
    min-width-0
  >
    <rt-truncate min-width-0>
      <ng-container [ngTemplateOutlet]="preferredLocationTextTpl"></ng-container>
    </rt-truncate>
  </div>
} @else {
  <div
    [rtTooltip]="workLocationsTooltip()"
    [rtTooltipEnabled]="workLocationsTooltipEnabled()"
    [rtTooltipPosition]="'below'"
    min-width-0
  >
    <rt-button variant="plain" size="small" (click)="edit.emit()">
      <rt-truncate min-width-0>
        <ng-container *ngTemplateOutlet="preferredLocationTextTpl"></ng-container>
      </rt-truncate>
      @if (!workLocations().length) {
        <rt-icon class="edit-icon" sufix name="edit" [size]="small ? 'small-x' : 'small'"></rt-icon>
      }
    </rt-button>
  </div>
}

<ng-template #preferredLocationTextTpl>
  @if (!workLocations().length) {
    @if (emptyStateTemplate) {
      <ng-container *ngTemplateOutlet="emptyStateTemplate"></ng-container>
    } @else {
      {{ 'app.candidate.placements.no_work_location_assigned' | translate }}
    }
  }
  @if (workLocations().length) {
    @if (workLocations().length === 1) {
      <span class="location-text" [attr.color-text-strong]="colorTextStrong ? true : null">
        {{ workLocations()[0] }}
      </span>
    } @else {
      <span [attr.color-text-strong]="colorTextStrong ? true : null">
        {{ workLocations().length }}
        {{ 'app.plurals.location' | translate: { count: workLocations().length } }}
      </span>
    }
  }
</ng-template>
